// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row-style{
   
        display: flex;
        flex-direction: row;
        width: 100%;
        align-items: center;
        justify-content: center;
     
}
.userform-header{
        text-align: center;
        background-color: #A25035;
        font-family: Merriweather Sans;
        font-weight: 500;
        color: #fff;
        position: sticky;
        top: 0;
        z-index: 100;
}

.userform-footer{
        text-align: center;
        font-family: Merriweather Sans;
        font-weight: 500;
        background-color: #fff;
        position: sticky;
        bottom: 0;
        z-index: 100;
}
.userform-container{
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        align-items: center;
        justify-content: center;
        width: 49vw;
        margin: 0 auto;
        padding: 0%;
}
.userform-outercard{
        height: 95%;
        overflow: auto;
        margin: auto;
        margin-top: 1.5%;
        width: 97%;
}
.userform-fieldstyle1{
        display: inline-block;
        margin: 1%;
        width: 100%;
}
.userform-fieldstyle2{
        width: 100%;
}
.userform-fieldstyle3{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
}
.role-errormsg{
        color: red;
}
.formButton-div{
        display: flex;
        align-items: center;
        justify-content: center;
}
.formButton{
        background-color: #A25035;
        color: #fff;
        border: none;
        margin-right: 1%;
}



`, "",{"version":3,"sources":["webpack://./src/components/modules/userManagement/resourceManagement/EditUser.css"],"names":[],"mappings":"AAAA;;QAEQ,aAAa;QACb,mBAAmB;QACnB,WAAW;QACX,mBAAmB;QACnB,uBAAuB;;AAE/B;AACA;QACQ,kBAAkB;QAClB,yBAAyB;QACzB,8BAA8B;QAC9B,gBAAgB;QAChB,WAAW;QACX,gBAAgB;QAChB,MAAM;QACN,YAAY;AACpB;;AAEA;QACQ,kBAAkB;QAClB,8BAA8B;QAC9B,gBAAgB;QAChB,sBAAsB;QACtB,gBAAgB;QAChB,SAAS;QACT,YAAY;AACpB;AACA;QACQ,aAAa;QACb,sBAAsB;QACtB,gBAAgB;QAChB,mBAAmB;QACnB,uBAAuB;QACvB,WAAW;QACX,cAAc;QACd,WAAW;AACnB;AACA;QACQ,WAAW;QACX,cAAc;QACd,YAAY;QACZ,gBAAgB;QAChB,UAAU;AAClB;AACA;QACQ,qBAAqB;QACrB,UAAU;QACV,WAAW;AACnB;AACA;QACQ,WAAW;AACnB;AACA;QACQ,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,WAAW;AACnB;AACA;QACQ,UAAU;AAClB;AACA;QACQ,aAAa;QACb,mBAAmB;QACnB,uBAAuB;AAC/B;AACA;QACQ,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,gBAAgB;AACxB","sourcesContent":[".row-style{\n   \n        display: flex;\n        flex-direction: row;\n        width: 100%;\n        align-items: center;\n        justify-content: center;\n     \n}\n.userform-header{\n        text-align: center;\n        background-color: #A25035;\n        font-family: Merriweather Sans;\n        font-weight: 500;\n        color: #fff;\n        position: sticky;\n        top: 0;\n        z-index: 100;\n}\n\n.userform-footer{\n        text-align: center;\n        font-family: Merriweather Sans;\n        font-weight: 500;\n        background-color: #fff;\n        position: sticky;\n        bottom: 0;\n        z-index: 100;\n}\n.userform-container{\n        display: flex;\n        flex-direction: column;\n        overflow-y: auto;\n        align-items: center;\n        justify-content: center;\n        width: 49vw;\n        margin: 0 auto;\n        padding: 0%;\n}\n.userform-outercard{\n        height: 95%;\n        overflow: auto;\n        margin: auto;\n        margin-top: 1.5%;\n        width: 97%;\n}\n.userform-fieldstyle1{\n        display: inline-block;\n        margin: 1%;\n        width: 100%;\n}\n.userform-fieldstyle2{\n        width: 100%;\n}\n.userform-fieldstyle3{\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n}\n.role-errormsg{\n        color: red;\n}\n.formButton-div{\n        display: flex;\n        align-items: center;\n        justify-content: center;\n}\n.formButton{\n        background-color: #A25035;\n        color: #fff;\n        border: none;\n        margin-right: 1%;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
